/*FOR CONDITIONAL NEED TO ADD THE NEXT LINES
For validations
validations:[
{
  type: 'required',
  message: 'Campo requerido'
},
{
  type: 'min',
  value: 0,
  message: 'Debe ser mayor a 0'
}
  ]
conditional: { 
  field: 'status',
  values:[6],
  validations: [
    { type: 'required', message: 'Campo requerido' },
  ]
}

*/
const CommentsFields = [
  {
    name: 'comments_internal',
    inputType: 'textarea',
    colSize: 12,
    label: 'Comentario Interno',
    type: 'string',
    validations: [
      {
        type: 'required',
        message: 'Campo requerido',
      },
      {
        type: 'typeError',
        message: 'Campo requerido',
      },
    ],
  },
  {
    name: 'comments',
    inputType: 'textarea',
    colSize: 12,
    label: 'Comentario',
    type: 'string',
    validations: [
      {
        type: 'required',
        message: 'Campo requerido',
      },
      {
        type: 'typeError',
        message: 'Campo requerido',
      },
    ],
  },
]

const PrincipalFields = [
  {
    name: 'comments_internal',
    inputType: 'textarea',
    colSize: 12,
    label: 'Comentario Interno',
    type: 'string',
    validations: [
      {
        type: 'required',
        message: 'Campo requerido',
      },
      {
        type: 'typeError',
        message: 'Campo requerido',
      },
    ],
  },
  {
    name: 'comments',
    inputType: 'textarea',
    colSize: 12,
    label: 'Comentario',
    type: 'string',
    validations: [
      {
        type: 'required',
        message: 'Campo requerido',
      },
      {
        type: 'typeError',
        message: 'Campo requerido',
      },
    ],
  },
  {
    name: 'attachments',
    inputType: 'attachments',
    invisible: true,
  },
]

export const FieldsNew = [
  // ...PrincipalFields,
  {
    name: 'status',
    inputType: 'choosen',
    colSize: 4,
    label: 'Estado',
    type: 'string',
    validations: [
      {
        type: 'required',
        message: 'Campo requerido',
      },
      {
        type: 'typeError',
        message: 'Campo requerido',
      },
    ],
  },
]

export const SolvedFields = [
  // ...PrincipalFields,
  {
    name: 'status',
    inputType: 'choosen',
    colSize: 4,
    label: 'Estado',
    type: 'string',
    validations: [
      {
        type: 'required',
        message: 'Campo requerido',
      },
      {
        type: 'typeError',
        message: 'Campo requerido',
      },
    ],
  },
  ...PrincipalFields,
]

export const FieldsCommentsNew = [
  // ...PrincipalFields,
  {
    name: 'status',
    inputType: 'choosen',
    colSize: 4,
    label: 'Estado',
    type: 'string',
    validations: [
      {
        type: 'required',
        message: 'Campo requerido',
      },
      {
        type: 'typeError',
        message: 'Campo requerido',
      },
    ],
  },
  ...CommentsFields,
]

export const CancelFields = [
  {
    name: 'status',
    inputType: 'choosen',
    colSize: 4,
    label: 'Estado',
    type: 'string',
    validations: [
      {
        type: 'required',
        message: 'Campo requerido',
      },
      {
        type: 'typeError',
        message: 'Campo requerido',
      },
    ],
  },
  {
    name: 'manager_group',
    inputType: 'choosen',
    colSize: 6,
    label: 'Responsable',
    type: 'string',
    validations: [],
  },
  {
    name: 'cancel_reason',
    inputType: 'choosen',
    colSize: 12,
    label: 'Motivo',
    type: 'string',
    validations: [],
  },
  ...PrincipalFields,
  /* {
    name: 'date',
    inputType: 'date',
    colSize: 12,
    label: 'Fecha',
    type: 'string',
    validations: [],
  }, */
]

export const ExecutionFields = [
  {
    name: 'status',
    inputType: 'choosen',
    colSize: 4,
    label: 'Estado',
    type: 'string',
    validations: [
      {
        type: 'required',
        message: 'Campo requerido',
      },
      {
        type: 'typeError',
        message: 'Campo requerido',
      },
    ],
  },
  {
    name: 'manager_group',
    inputType: 'choosen',
    colSize: 6,
    label: 'Responsable',
    type: 'string',
    validations: [],
  },
  ...PrincipalFields,
]

export const PlanificationFields = [
  {
    name: 'status',
    inputType: 'choosen',
    colSize: 4,
    label: 'Estado',
    type: 'string',
    validations: [
      {
        type: 'required',
        message: 'Campo requerido',
      },
      {
        type: 'typeError',
        message: 'Campo requerido',
      },
    ],
  },
  {
    name: 'manager_group',
    inputType: 'choosen',
    colSize: 6,
    label: 'Responsable',
    type: 'string',
    validations: [
      {
        type: 'required',
        message: 'Campo requerido',
      },
      {
        type: 'typeError',
        message: 'Campo requerido',
      },
    ],
  },
  {
    name: 'planning_date',
    inputType: 'date',
    colSize: 12,
    label: 'Fecha',
    type: 'string',
    validations: [],
  },
  ...CommentsFields,
]

export const validateFields = [
  {
    name: 'status',
    inputType: 'choosen',
    colSize: 4,
    label: 'Estado',
    type: 'string',
    validations: [
      {
        type: 'required',
        message: 'Campo requerido',
      },
      {
        type: 'typeError',
        message: 'Campo requerido',
      },
    ],
  },
  ...PrincipalFields,
]

export const informFields = [
  {
    name: 'status',
    inputType: 'choosen',
    colSize: 4,
    label: 'Estado',
    type: 'string',
    validations: [
      {
        type: 'required',
        message: 'Campo requerido',
      },
      {
        type: 'typeError',
        message: 'Campo requerido',
      },
    ],
  },
  ...PrincipalFields,
]

export const PlannedFields = [
  {
    name: 'status',
    inputType: 'choosen',
    colSize: 4,
    label: 'Estado',
    type: 'string',
    validations: [
      {
        type: 'required',
        message: 'Campo requerido',
      },
      {
        type: 'typeError',
        message: 'Campo requerido',
      },
    ],
  },
  ...CommentsFields,
]
